module.exports = __webpack_public_path__ + "img/b.88bea5b0.jpg";